const $ = require('jquery')
const Vue = require('vue')
const guid = require('sci/helpers/guid')
const R = require('ramda')
const elasticlunr = require('elasticlunr')
const S = require('string')

const KEY_NOT_FOUND = Symbol('KEY_NOT_FOUND')

class OptionsIndex {
    constructor(options, display, identifier) {
        this.display = display
        this.identifier = identifier

        this.options = R.clone(options).map((item) => {
            item.$display = item[this.display]
            item.$id = item[this.identifier]

            item.$searchable = S(item.$display).latinise().s
            item.$uid = guid()

            return item
        }, {})
    }

    all () {
        return R.sortBy(R.prop('$searchable'), this.options);
    }

    nonEmpty() {
        return this.options.length > 0;
    }

    has(key) {
        return this.get(key) !== KEY_NOT_FOUND
    }

    get(key) {
        const matches = this.options.filter(_ => _.$uid === key)

        if (matches.length < 1) {
            return KEY_NOT_FOUND
        }

        return matches[0]
    }

    hasValue(key) {
        return this.options.some((option) => {
            return option.$id === key || lazyEquals(option.$id, key)
        })
    }

    getByValue(key) {
        return R.head(
            this.options.filter((option) => {
                return option.$id === key || lazyEquals(option.$id, key)
            })
        )
    }
}

elasticlunr.clearStopWords()

const lazyEquals = (v1, v2) => {
    return String(v1) === String(v2)
}

const nullify = (value) => {
    if (value === '') {
        return null
    }

    return value
}

const defaultFormat = (state) => state.text
const noop = (x) => x
const ellipsify = (template) => `<div style="margin-right: 0; display: block; position: relative; text-overflow: ellipsis; overflow: hidden;">${template}</div>`

const buildSelect2 = (engine, self, cb, value) => {
    const $select = $(self.$els.select)
    const extra = {}

    if (!self.sorter) {
        self.sorter = b => R.sortBy(item => item.text.toLowerCase(), b)
    }

    if (self.editable) {
        extra.tags = true
        extra.createTag = function (params) {
            const term = $.trim(params.term)

            if (term.length < 1) {
                return null
            }

            return {
                id: term,
                text: term,
                newTag: true
            }
        }
    }

    let cancelSearch = null

    let selected = null

    if (self.optionsIndex.hasValue(self.model)) {
        selected = self.optionsIndex.getByValue(self.model)
    }

    const placeholder = {
        id: null,
        text: self.placeholder || 'Selecione...'
    }

    $select
        .prop('disabled', self.disabled)
        .empty()
        .unbind()
        .select2({
            language: {
                errorLoading: function () {
                    return 'Os resultados não puderam ser carregados.'
                },
                inputTooLong: function (args) {
                    const overChars = args.input.length - args.maximum

                    let message = 'Apague ' + overChars + ' caracter'

                    if (overChars !== 1) {
                        message += 'es'
                    }

                    return message
                },
                inputTooShort: function (args) {
                    const remainingChars = args.minimum - args.input.length

                    return 'Digite ' + remainingChars + ' ou mais caracteres'
                },
                loadingMore: function () {
                    return 'Carregando mais resultados…'
                },
                maximumSelected: function (args) {
                    let message = 'Você só pode selecionar ' + args.maximum + ' ite'

                    if (args.maximum === 1) {
                        message += 'm'
                    } else {
                        message += 'ns'
                    }

                    return message
                },
                noResults: function () {
                    return 'Nenhum resultado encontrado'
                },
                searching: function () {
                    return 'Buscando…'
                }
            },
            initSelection: selected ? function (select, callback) {
                try {
                    callback({
                        id: selected.$uid,
                        text: selected.$display,
                        original: Object.assign({}, selected)
                    })
                } catch (e) {
                    console.error(e)
                }
            } : null,
            placeholder,
            tags: false,
            sorter: self.sorter,
            // dropdownParent: $select.closest('.__dropdown-holder'),
            // minimumResultsForSearch: 5,
            id: guid(),
            theme: 'bootstrap',
            dropdownAutoWidth: false,
            width: 'auto',
            groups: false,
            allowClear: self.allowEmpty,
            templateResult: (state, container) => {
                if (self.templateResult && self.templateResult !== defaultFormat) {
                    if ((state.original && state.original.hasOwnProperty(self.identifier)) || state.hasOwnProperty(self.identifier)) {
                        return self.templateResult(state.original, container)
                    }
                }

                return defaultFormat(state, container)
            },
            templateSelection: (state, container) => {
                if (self.templateSelection && self.templateSelection !== defaultFormat) {
                    if ((state.original && state.original.hasOwnProperty(self.identifier)) || state.hasOwnProperty(self.identifier)) {
                        const template = self.templateSelection(state.original, container)

                        return ellipsify(template)
                    }
                }

                const template = defaultFormat(state, container)

                return ellipsify(template)
            },
            escapeMarkup: self.formatResult !== defaultFormat ? noop : undefined,
            ajax: {
                transport: function (params, success, failure) {
                    if (cancelSearch) {
                        clearTimeout(cancelSearch)
                    }

                    // Paraleliza a busca para evitar ui hang
                    cancelSearch = setTimeout(() => {
                        Promise.resolve().then(() => {
                            const term = params.data.term || ''

                            if (!term) {
                                return success(self.optionsIndex.all())
                            }

                            const searchResult = engine.search(S(term).latinise().s, {
                                fields: {
                                    text: {
                                        bool: 'AND',
                                        expand: true
                                    }
                                }
                            })

                            const result = searchResult.map(item => {
                                if (self.optionsIndex.has(item.ref)) {
                                    return self.optionsIndex.get(item.ref)
                                }

                                return null
                            }).filter(_ => !!_)

                            success(result)
                        })
                    }, 1)
                },
                processResults: function (result, params) {
                    try {
                        let items = result

                        if (self.processResult) {
                            items = self.processResult(items, params.term || null)
                        }

                        items = items.map(item => {
                            if (item.hasOwnProperty('__auto')) {
                                return item
                            }

                            // item.original = Object.assign({}, item)
                            // item.text = item[self.display]
                            // item[self.identifier] = item[self.identifier]
                            // item.id = item[self.identifier]
                            // item.children = null

                            return {
                                id: item.$uid,
                                text: item.$display,
                                disabled: R.propOr(false, 'disabled', item),
                                original: Object.assign({}, item)
                            }
                        })

                        return {
                            results: items
                        }
                    } catch (e) {
                        console.error(e)

                        return null
                    }
                },
                cache: true
            },
            ...extra
        })
        .on('change', function () {
            cb.apply(this, arguments)
        })

    // $select.val(value).trigger('change', true)
}

Vue.component('form-select', {
    props: {
        editable: {
            type: Boolean,
            default: false
        },
        hasLabel: {
            type: Boolean,
            default: true
        },
        label: {
            type: String
        },
        identifier: {
            type: String,
            default: 'id'
        },
        display: {
            type: String,
            default: 'name'
        },
        placeholder: {
            type: String
        },
        iconClass: {
            type: String
        },
        model: {
            twoWay: true,
            default: null
        },
        options: {
            default () {
                return []
            },
            type: Array
        },
        disabled: {
            default: false,
            type: Boolean
        },
        onChange: {
            default: null,
            type: Function
        },
        onPrefetched: {
            default: null,
            type: Function
        },
        onAfterChanged: {
            default: null,
            type: Function
        },
        allowEmpty: {
            type: Boolean,
            default: true
        },
        hintIcon: {
            type: String,
            default: 'fa-question-circle'
        },
        hintClass: {
            type: String,
            default: null
        },
        hint: {
            type: String,
            default: null
        },
        name: {
            type: String,
            default: null
        },
        templateResult: {
            type: Function,
            default: defaultFormat
        },
        templateSelection: {
            type: Function,
            default: defaultFormat
        },
        processResult: {
            type: Function,
            default: null
        },
        sorter: {
            type: Function,
            default: null
        },
        width: {
            default: null,
        }
    },
    watch: {
        disabled () {
            $(this.$els.select).prop('disabled', this.disabled)
        },
        options (newVal, oldVal) {
            this.reload()
        },
        placeholder () {
            this.reload()
        },
        model (newVal, oldVal) {
            this.reload()
        }
    },
    computed: {
        containerWidth() {
            return {
                position: 'relative',
                width: this.width || 'auto'
            }
        }
    },
    methods: {
        hasLabel () {
            return !!this.label || this.$hasSlot('label')
        },
        hasAppend () {
            return this.$hasSlot('append')
        },
        holderClass () {
            return {
                'input-icon': !!this.iconClass
            }
        },
        inputHolderClass () {
            return {
                'input-icon': !!this.iconClass,
                'input-group': this.hasAppend()
            }
        },
        getHint () {
            if (this.hint) {
                return this.hint
            }
        },
        reload () {
            const self = this

            self.optionsIndex = new OptionsIndex(this.options || [], this.display, this.identifier)

            if (this.onPrefetched && self.optionsIndex.nonEmpty) {
                // const item = R.head(this.options.filter((opt) => {
                //     return lazyEquals(opt[this.identifier], this.model)
                // }))
                const item = self.optionsIndex.getByValue(this.model)

                this.onPrefetched(this.mode, item)
            }

            this.buildEngine().then((engine) => {
                buildSelect2(engine, self, function (evt, ignore) {
                    if (ignore) {
                        return
                    }

                    let id = null
                    let original = null

                    const s2Value = $(this).select2('data')[0]

                    if (s2Value && !s2Value.newTag) {
                        const value = self.optionsIndex.get(s2Value.id)

                        if (value !== KEY_NOT_FOUND) {
                            original = value
                            id = (!R.isNil(original.$id) && !R.isEmpty(original.$id)) ? original.$id : null
                        }
                    }

                    // else if (s2Value && s2Value.newTag) {
                    //     const term = value.text

                    //     self.options = self.options.filter(_ => !_.__custom).concat([
                    //         {
                    //             id: term,
                    //             text: term,
                    //             name: term
                    //         }
                    //     ])
                    // }

                    if (self.onChange) {
                        self.onChange(id, original)
                    }

                    self.model = id

                    if (self.onAfterChanged) {
                        self.onAfterChanged(id, original)
                    }
                }, self.model)
            })
        },
        focus () {
            Vue.nextTick(() => {
                const field = $(this.$els.select)
                field.select2('focus')
                field.select2('open')
            })
        },
        buildEngine () {
            const self = this

            return Promise.resolve().then(() => {
                this.engine = elasticlunr(function () {
                    this.addField('text')

                    this.setRef('$uid')

                    self.optionsIndex.all().forEach((item) => {
                        this.addDoc({
                            text: item.$searchable,
                            $uid: item.$uid,
                            $id: item.$id
                        })
                    })
                })

                return this.engine
            })
        },
        close () {
            Vue.nextTick(() => {
                const field = $(this.$els.select)
                field.select2('close')
            })
        }
    },
    data () {
        return {
            fieldName: ''
        }
    },
    ready () {
        this.fieldName = this.name || this._props.model.raw

        if (!this.placeholder) {
            this.placeholder = this.label
        }

        this.reload()
    },
    template: `
            <div class="form-group">
                <form-label v-if="hasLabel()" :hint="getHint()" :hint-class="hintClass" :hint-icon="hintIcon">
                    <slot name="label">
                        {{ label }}
                    </slot>
                </form-label>
                <div v-bind:class="holderClass()" class="__dropdown-holder" :style="containerWidth">
                    <i v-bind:class="iconClass" v-if="iconClass"></i>
                    <div v-bind:class="inputHolderClass()">
                        <select class="form-control"
                                v-el:select
                                v-bind:data-field="fieldName"
                                v-bind:disabled="disabled">
                                <option v-if="allowEmpty" value=""></option>
                        </select>
                    </div>
                </div>
            </div>
        `
})



// WEBPACK FOOTER //
// ./resources/assets/javascript/sci/components/form/select.js